

export default function Skill(props) {
  return (
    <div className="card-wrap">
      <div className={`card-header ${props.color}`}>
        {props.cmpt}
      </div>
      <div className="card-content">
          <h1 className="card-title">{props.title}</h1>
          <p className="card-text">{props.desc}</p>
          <button className={`card-btn ${props.color}`}>My Projects</button>
      </div>
    </div>
  )
}
